import { createContext, useContext } from "react";
import type { ReleaseStage } from "@/components/release-stage-badge";

export interface CommandAction {
  id: string;
  label: string;
  icon?: string;
  shortcut?: string;
  onSelect: () => void;
  group?: string;
  /** Release stage of the target (e.g. a pre-GA page); renders a badge. */
  stage?: ReleaseStage;
}

interface CommandPaletteContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  actions: CommandAction[];
  setActions: (actions: CommandAction[]) => void;
  addActions: (actions: CommandAction[]) => void;
  removeActions: (ids: string[]) => void;
  contextBadge: string | null;
  setContextBadge: (badge: string | null) => void;
}

export const CommandPaletteContext = createContext<
  CommandPaletteContextType | undefined
>(undefined);

export function useCommandPalette(): CommandPaletteContextType {
  const context = useContext(CommandPaletteContext);
  if (!context) {
    throw new Error(
      "useCommandPalette must be used within CommandPaletteProvider",
    );
  }
  return context;
}
